<!-- Footer -->
<footer class="text-center text-lg-start " style="background-color: #184e77; color: #8e9aaf; margin-top: 200px">
  <!-- Section: Social media -->
  <section
    class="d-flex  justify-content-lg-between p-4 border-bottom"
  >
    <!-- Left -->
    <div class="me-5 d-none d-lg-block">
      <span style="color: #ced4da">Get connected with social networks:</span>
    </div>
    <!-- Left -->

    <!-- Right -->
    <div>
      <a href="https://www.linkedin.com/in/venoligamage/" class="me-4 container justify-content-around" style="color: #ced4da">
        <i class="fab fa-linkedin"></i>
      </a>
      <a href="https://github.com/Venoli" class="me-4 container justify-content-around" style="color: #ced4da">
        <i class="fab fa-github"></i>
      </a>
      <a href="https://www.youtube.com/channel/UCOTivpqaLImYQO_YGSnzyKg" class="me-4 container justify-content-around" style="color: #ced4da">
        <i class="fab fa-youtube"></i>
      </a>

      <a href="https://www.instagram.com/venoligamage/" class="me-4 container justify-content-around" style="color: #ced4da">
        <i class="fab fa-instagram"></i>
      </a>
      <a href="https://www.facebook.com/venoli.gamage" class="me-4  container justify-content-around" style="color: #ced4da">
        <i class="fab fa-facebook-f"></i>
      </a>
      <a href="https://twitter.com/Venus83377331" class="me-4  container justify-content-around" style="color: #ced4da">
        <i class="fab fa-twitter"></i>
      </a>



    </div>
    <!-- Right -->
  </section>
  <!-- Section: Social media -->

  <!-- Section: Links  -->
  <section class="">
    <div class="container text-center text-md-start mt-5">
      <!-- Grid row -->
      <div class="row mt-3">
        <!-- Grid column -->
        <div class="col-md-3 col-lg-4 col-xl-3 mx-auto mb-4">
          <!-- Content -->
          <h6 class="text-uppercase fw-bold mb-4 ">
            <i class="fas fa-gem me-3" style="color: #f4acb7"></i> Asips
          </h6>
          <p >
            Asips demonstrate the use of a novel algorithm on HTRU2 dataset and it provides the capability
            of comparing different algorithms.
          </p>
        </div>
        <!-- Grid column -->

        <!-- Grid column -->
        <div class="col-md-2 col-lg-2 col-xl-2 mx-auto mb-4">
          <!-- Links -->
          <h6 class="text-uppercase fw-bold mb-4">
            Technologies
          </h6>
          <p>
            <a href="https://www.python.org/" class="text-reset">Python</a>
          </p>
          <p>
            <a href="https://angular.io/" class="text-reset">Angular</a>
          </p>
          <p>
            <a href="https://firebase.google.com/" class="text-reset">Firebase</a>
          </p>
          <p>
            <a href="https://scikit-multiflow.github.io/" class="text-reset">Scikit-Multiflow</a>
          </p>
        </div>
        <!-- Grid column -->

        <!-- Grid column -->
        <div class="col-md-3 col-lg-2 col-xl-2 mx-auto mb-4">
          <!-- Links -->
          <h6 class="text-uppercase fw-bold mb-4">
            References
          </h6>
          <p>
            <a href="https://doi.org/10.1093/mnras/stw656" class="text-reset">Lyon et al., 2016</a>
          </p>
          <p>
            <a href="https://arxiv.org/pdf/1802.08780.pdf" class="text-reset">Manapragada, Webb and Salehi, 2018</a>
          </p>
          <p>
            <a href="https://ieeexplore.ieee.org/abstract/document/6977056" class="text-reset">Lyon et al., 2014</a>
          </p>
          <p>
            <a href="https://jmlr.org/papers/v19/18-251.html" class="text-reset">Montiel et al., 2018</a>
          </p>
        </div>
        <!-- Grid column -->

        <!-- Grid column -->
        <div class="col-md-4 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-4">
          <!-- Links -->
          <h6 class="text-uppercase fw-bold mb-4">
            Contact
          </h6>
          <p><i class="fas fa-home me-3" style="color: #6096ba" ></i> Colombo, Sri Lanka</p>
          <p>
            <i class="fas fa-envelope me-3" style="color: #b8dbd9" ></i> venolishehara@gmail.com
          </p>
          <p><i class="fas fa-phone me-3" style="color: #8d86c9" ></i> + 94 71 XXXX XXX</p>
          <p><i class="fas fa-coffee me-3" style="color: #b97375" ></i>
            <a href="https://www.buymeacoffee.com/venoli" class="text-reset"> Buy me a coffee</a></p>
        </div>
        <!-- Grid column -->
      </div>
      <!-- Grid row -->
    </div>
  </section>
  <!-- Section: Links  -->

  <!-- Copyright -->
  <div class="text-center p-4 " style="background-color: rgba(0, 0, 0, 0.2); color: #8e9aaf">
    © 2021 Copyright:
    <a style="color: #8e9aaf" href="https://www.linkedin.com/in/venoligamage/">Venoli Gamage</a>
  </div>
  <!-- Copyright -->
</footer>
<!-- Footer -->
